'use client';

import { trackException } from '@/lib/appInsights';
import React, { useEffect } from 'react';
import {
  APP_ERROR_SPLASH_CHUNK_DESCRIPTION,
  ChunkLoadErrorSplash,
} from '@/components/ChunkLoadErrorSplash';
import { isChunkLoadError, isChunkLoadErrorSplashEnabled } from '@/utils/chunkLoadError';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const reloadPage = () => {
  window.location.reload();
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  useEffect(() => {
    trackException(error);
  }, [error]);

  if (isChunkLoadErrorSplashEnabled()) {
    return (
      <ChunkLoadErrorSplash
        onRetry={isChunkLoadError(error) ? reloadPage : resetErrorBoundary}
        description={isChunkLoadError(error) ? APP_ERROR_SPLASH_CHUNK_DESCRIPTION : undefined}
      />
    );
  }

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button type="button" onClick={resetErrorBoundary}>
        Try again
      </button>
    </div>
  );
};

export default ErrorFallback;
